import { useQuery } from '@apollo/client';

import { BoardTableRowDialogProps } from '@modules/board/BoardTableRowDialog/shared/types';
import { graphql } from 'src/generated';

const ROW_QUERY = graphql(`
  query TableRowQuery($rowId: ID!, $tableId: ID!, $boardId: ID!) {
    row: tableRow(input: { tableId: $tableId, rowId: $rowId }) {
      ...tableRow
    }

    board(id: $boardId) {
      _id
      name
      ...BoardRoles
      ...BoardParticipants
    }

    table(input: { boardId: $boardId, tableId: $tableId }) {
      _id
      name
      columns {
        ...TableColumn
      }
      views {
        ...tableView
        columns {
          ...TableViewColumn
        }
      }
    }
  }
`);

export const useRowViewQuery = ({
  boardId,
  rowId,
  tableId,
}: Omit<BoardTableRowDialogProps, 'handleReOpen' | 'viewId'>) => {
  const { data, loading } = useQuery(ROW_QUERY, {
    variables: { tableId, rowId, boardId },
  });

  return {
    board: data?.board,
    row: data?.row,
    table: data?.table,
    isLoading: loading,
  };
};
